import useCrud from "../base/crud";

const defaultSettings = {
  page: 1,
  filters: { "entityStatus.status#eq": "ACTIVE" },
  withGraphFetched:
    "[role, mobileApps, country.[stringResources.[translations(filterByCurrentLanguage).[language]]], companyDetails.[country.[stringResources.[translations(filterByCurrentLanguage).[language]]]]]",
  userType: null
};

const user = (settings = defaultSettings, suffix) => {
  const { error, loading, actions, list, data, pagination } = useCrud(
    "user",
    { ...defaultSettings, ...settings },
    "/V2",
    undefined,
    suffix
  );

  return { error, loading, actions, list, pagination, data };
};

export default user;
